// @ts-nocheck
import { css } from 'styled-components';
import get from 'lodash/get';
import { pxToRem } from '@fil-react-mixins/styled';
const sizeToStrokeMap = {
    16: 1.5,
    20: 1.5,
    24: 1.5,
    32: 1.5,
    36: 1.5,
    48: 2.5,
    64: 2.5,
};
const sizeToOffsetMap = {
    16: -2,
    20: -3,
    24: -4,
    32: -4,
    36: -6,
    48: -8,
    64: -12,
};
const iconContrasts = {
    'blue.400': 'grey.900',
    'blue.500': 'brand.white',
    'blue.600': 'brand.white',
    'blue.800': 'blue.100',
    'blue.900': 'blue.200',
    'teal.400': 'grey.800',
    'teal.500': 'grey.800',
    'teal.600': 'brand.white',
    'teal.800': 'brand.white',
    'green.400': 'grey.800',
    'green.500': 'grey.800',
    'green.600': 'brand.white',
    'green.800': 'brand.white',
    'yellow.400': 'grey.600',
    'yellow.500': 'grey.800',
    'yellow.600': 'grey.800',
    'yellow.800': 'grey.800',
    'orange.400': 'grey.800',
    'orange.500': 'grey.800',
    'orange.600': 'grey.800',
    'orange.800': 'brand.white',
    'purple.400': 'brand.white',
    'purple.500': 'brand.white',
    'purple.600': 'brand.white',
    'purple.800': 'brand.white',
    'grey.050': 'grey.500',
    'grey.100': 'grey.500',
    'grey.200': 'grey.600',
    'grey.300': 'grey.800',
    'grey.400': 'grey.900',
    'grey.500': 'grey.100',
    'grey.600': 'grey.200',
    'grey.700': 'grey.200',
    'grey.800': 'grey.300',
    'grey.900': 'grey.400',
    'brand.black': 'brand.white',
    'brand.error-red': 'brand.white',
};
export default css `
  display: inline-block;
  vertical-align: middle;
  line-height: 0;
  font-size: 0;
  ${(props) => props.iconColor &&
    css `
      color: ${get(props.theme.color.base, `${props.iconColor}.value`)};
    `}

  .fil-svg-icon {
    stroke-linecap: round;
    stroke-linejoin: round;
    position: relative;
    ${({ size = 24, strokeWidth }) => css `
      width: ${pxToRem(size)};
      height: ${pxToRem(size)};
      stroke-width: ${strokeWidth || sizeToStrokeMap[size] || 1.5}px;
    `}

    ${({ position, size = 24 }) => position &&
    css `
        position: relative;
        ${position}: ${pxToRem(sizeToOffsetMap[size] || -2)};
      `}

    ${(props) => props.filled &&
    css `
        stroke: none;
        fill: currentColor;

        // SVG elements that need to get colored if an icon is inverted
        [class$='icon__properties'] {
          stroke: white;
          fill: none;
          ${props.iconColor &&
        iconContrasts[props.iconColor] &&
        css `
            stroke: ${get(props.theme.color.base, `${iconContrasts[props.iconColor]}.value`)};
          `}
        }
      `}

    line, circle, g , polyline, polygon, rect, ellipse, path {
      vector-effect: non-scaling-stroke;
    }
  }
`;
